import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'antd';
import './ReenviarSolicitacao.css';
import SelecionarFornecedor from '../Fornecedores/SelecionarFornecedor';


const ReenviarSolicitacao = ({ visible, onClose, onConfirm, itens, idSolicitacao }) => {
  // ...restante do código
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showSelecionarFornecedor, setShowSelecionarFornecedor] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Bloqueia/desbloqueia o scroll do fundo ao abrir/fechar o modal (mobile)
  useEffect(() => {
    const homeContainer = document.querySelector('.home-container');
    if ((visible || showSelecionarFornecedor) && isMobile) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      if (homeContainer) homeContainer.classList.add('no-scroll');
    } else {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (homeContainer) homeContainer.classList.remove('no-scroll');
    }
    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (homeContainer) homeContainer.classList.remove('no-scroll');
    };
  }, [visible, isMobile, showSelecionarFornecedor]);

  // Handler para abrir o modal de fornecedores e fechar este
  const handleReenviarItens = () => {
    setShowSelecionarFornecedor(true);
  };

  // Handler para fechar o modal de fornecedores e reabrir o de itens faltantes
  const handleFecharSelecionarFornecedor = () => {
    setShowSelecionarFornecedor(false);
    // Reabre o modal de itens faltantes se necessário
    if (onClose) onClose();
  };

  return (
    <>
      <Modal
        title="Itens Faltantes"
        open={visible && !showSelecionarFornecedor}
        onCancel={onClose}
        destroyOnClose={true}
        maskClosable={true}
        footer={[
          <Button key="cancelar" onClick={onClose}
            style={{
              background: '#fff',
              color: '#d32f2f',
              border: '1.5px solid #d32f2f',
              height: 48,
              fontSize: '1.15rem',
              minWidth: 160
            }}
          >Cancelar</Button>,
          <Button key="reenviar" type="primary" onClick={handleReenviarItens}
            style={{
              background: 'linear-gradient(90deg, #001f4d 60%, #003380 100%)',
              color: '#fff',
              border: 'none',
              height: 48,
              fontSize: '1.15rem',
              minWidth: 160
            }}
          >Reenviar Itens</Button>
        ]}
      >
        {isMobile ? (
          <div>
            {itens.map(item => (
              <div key={item.id || item.IT_ID || item.ITE_ID} className="inserir-cotacao-card">
                <div><b>Descrição:</b> {item.descricao || item.ITE_DESCRICAO || item.IT_NOME || item.IT_DESCRICAO}</div>
                <div><b>Quantidade:</b> {item.quantidade || item.ITE_QUANTIDADE || item.IT_QUANTIDADE}</div>
              </div>
            ))}
          </div>
        ) : (
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left' }}>Descrição</th>
                <th style={{ textAlign: 'left' }}>Quantidade</th>
              </tr>
            </thead>
            <tbody>
              {itens.map(item => (
                <tr key={item.id || item.IT_ID || item.ITE_ID}>
                  <td>{item.descricao || item.ITE_DESCRICAO || item.IT_NOME || item.IT_DESCRICAO}</td>
                  <td>{item.quantidade || item.ITE_QUANTIDADE || item.IT_QUANTIDADE}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Modal>
      {showSelecionarFornecedor && (
        <SelecionarFornecedor
          onClose={handleFecharSelecionarFornecedor}
          solicitacaoId={idSolicitacao}
          onConfirm={(selecionados) => {
            setShowSelecionarFornecedor(false);
            if (onClose) onClose();
          }}
        />
      )}
    </>
  );
};

export default ReenviarSolicitacao;
